/**
 * USB barkod okuyucu ayırt etme (16 Eki 2026).
 *
 * Okuyucu klavye gibi davranıyor: barkodu karakter karakter, insanın
 * yazamayacağı hızda (karakter arası birkaç ms) yazıp Enter'a basıyor. Kasa
 * buradan geçen her tuşla bir tampon tutuyor; aralar SCAN_GAP_MS'den kısaysa
 * karakterler aynı okutmaya ait. Enter geldiğinde tampon en az MIN_SCAN_LEN
 * karakterse barkod.
 *
 * Kasanın 1-9 kısayolları bununla çakışıyordu: barkoddaki her rakam bir ürün
 * ekliyordu. Kısayol artık SCAN_GAP_MS kadar bekliyor; o arada başka karakter
 * gelirse okutmadır ve kısayol iptal.
 */
export const SCAN_GAP_MS = 50
export const MIN_SCAN_LEN = 4

export interface ScanState {
  chars: string
  last: number
}

export const EMPTY_SCAN: ScanState = { chars: '', last: 0 }

/** Barkodda olabilecek karakterler (EAN, UPC, Code128'in yaygın kısmı). */
const SCAN_CHAR = /^[0-9A-Za-z\-.]$/

/**
 * Bir tuşu tampona işler. `code`: Enter ile biten bir okutma tamamlandı.
 * `burst`: bu tuş hızlı bir dizinin parçası (tek başına basılmış değil).
 */
export function scanKey(
  state: ScanState,
  key: string,
  now: number,
): { state: ScanState; code?: string; burst: boolean } {
  const fast = state.chars.length > 0 && now - state.last <= SCAN_GAP_MS
  if (key === 'Enter') {
    const code = fast && state.chars.length >= MIN_SCAN_LEN ? state.chars : undefined
    return { state: EMPTY_SCAN, code, burst: fast }
  }
  if (!SCAN_CHAR.test(key)) return { state: EMPTY_SCAN, burst: false }
  const chars = fast ? state.chars + key : key
  return { state: { chars, last: now }, burst: chars.length > 1 }
}

/** Barkodu karşılaştırma için sadeleştirir: boşluklar gider, harfler büyük. */
export const normalizeBarcode = (s: string) => s.replace(/\s+/g, '').toUpperCase()
